module.exports = __webpack_public_path__ + "static/media/Begleitschreiben_AnkaufperPost_AT.e20f386f.pdf";